export enum DISCOUNT_FILTERS {
  SEARCH = 'search',
  START_TIME = 'start_time',
  END_TIME = 'end_time',
  VALIDITY = 'validity',
  SALE_ARTICLES = 'sale_articles',
}

export enum DISCOUNT_STATUS {
  VALID = 'valid',
  INVALID = 'invalid',
}

export const DISCOUNT_STATUS_FORMAT = {
  [DISCOUNT_STATUS.VALID]: 'success',
  [DISCOUNT_STATUS.INVALID]: 'warning',
} as const
